'use client';

import { useEffect, useState } from 'react';

import { Waypoint } from 'react-waypoint';

import DetailProjectPageNavigation from '@/app/[locale]/(business)/projects/[slug]/_components/tabs';
import { ProjectSectionElement } from '@/app/[locale]/(business)/projects/[slug]/types';
import { getHash } from '@/lib/url';

interface ProjectSectionsWithNavigationClientProps {
  sectionsToDisplay: ProjectSectionElement[];
  isPageLocked: boolean;
}

const ProjectSectionsWithNavigationClient = ({
  sectionsToDisplay,
  isPageLocked,
}: ProjectSectionsWithNavigationClientProps) => {
  const [hash, setHash] = useState<string | undefined>(undefined);

  const setNewHash = (hashName: string) => {
    setHash(hashName);
  };

  useEffect(() => {
    const firstHash = getHash();
    setHash(firstHash);
  }, []);

  return (
    <>
      <DetailProjectPageNavigation
        disabled={isPageLocked}
        sectionsToDisplay={sectionsToDisplay}
        hash={hash}
      />

      {sectionsToDisplay.map((section) => {
        return (
          <Waypoint
            topOffset="200px"
            key={section.name}
            onEnter={() => setNewHash(section.anchor)}
          >
            <div>{section.Element}</div>
          </Waypoint>
        );
      })}
    </>
  );
};

export default ProjectSectionsWithNavigationClient;
